import React from 'react'

import sample from 'lodash/sample'

import fullPath from './data/helpers/full_path'
import PresenceIndicator from './presence_indicator'

class ProfileImage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      defaultAvatars: [
        '/avatars/1.png',
        '/avatars/2.png',
        '/avatars/3.png',
        '/avatars/4.png',
        '/avatars/5.png',
        '/avatars/6.png',
        '/avatars/7.png',
        '/avatars/8.png',
        '/avatars/9.png',
        '/avatars/10.png',
        '/avatars/11.png',
        '/avatars/12.png',
        '/avatars/13.png',
        '/avatars/14.png',
        '/avatars/15.png',
        '/avatars/16.png',
        '/avatars/17.png',
        '/avatars/18.png',
        '/avatars/19.png',
        '/avatars/20.png',
        '/avatars/21.png',
        '/avatars/22.png',
        '/avatars/23.png'
      ]
    }
  }

  componentWillMount () {
    this.setState({sampleAvatar: sample(this.state.defaultAvatars)})
  }

  imageUrl () {
    return this.props.image || fullPath(this.state.sampleAvatar)
  }

  renderPresenceIndicator () {
    if (this.props.hasIndicator) {
      return <PresenceIndicator user={this.props.user} size={this.props.indicatorSize}/>
    }
  }

  renderProfileImage () {
    return <img src={this.imageUrl()} style={{width: this.props.size, height: this.props.size}}/>
  }

  render () {
    return (
      <div className="profile-image" style={{width: this.props.size, height: this.props.size}}>
        {this.renderProfileImage()}
        {this.renderPresenceIndicator()}
      </div>
    )
  }
}

ProfileImage.defaultProps = {
  hasIndicator: true
}


export default ProfileImage



/** WEBPACK FOOTER **
 ** ./modules/shared/profile_image.js
 **/